import { FC } from 'react';
import { V4 as C } from '@components/v4/tokens';
import type { Nudge } from './usePaulinaChat';

/**
 * PaulinaNudgeBanner — el nudge RELEVANTE como BANNER COMPACTO descartable, FIJO arriba del
 * cuerpo del chat (PaulinaConversation) cuando YA hay conversación. A diferencia de
 * PaulinaNudgeCard (la tarjeta completa del estado vacío), el banner:
 *   - NO es un mensaje y NO empuja la conversación (va fuera del scroll, pinned arriba),
 *   - es COMPACTO (una línea de título + acción), no la tarjeta entera,
 *   - así la sugerencia es SIEMPRE entregable aunque haya historial (no depende de que el
 *     historial se vacíe, que solo pasa tras logout/limpiar/usuario nuevo).
 *
 * Reusa los MISMOS handlers del hook (aceptarNudge/descartarNudge) que la tarjeta y el bubble de
 * desktop: el CTA funciona idéntico (navegar / abrir chat con prompt / escalar). Solo se monta para
 * nudges RELEVANTES; los tips de descubrimiento siguen suprimidos con historial (lo decide el
 * contenedor). El título lleva ellipsis para no romper el layout en mensajes largos.
 */

interface PaulinaNudgeBannerProps {
  nudge: Nudge;
  onAccept: (n: Nudge) => void;
  onDismiss: (n: Nudge) => void;
}

export const PaulinaNudgeBanner: FC<PaulinaNudgeBannerProps> = ({ nudge, onAccept, onDismiss }) => (
  <div
    role="group"
    aria-label={nudge.titulo}
    className="flex items-center gap-2 border-b px-3 py-2"
    style={{ background: C.primary, color: C.white, borderColor: 'rgba(255,255,255,.16)' }}
  >
    <p className="min-w-0 flex-1 truncate text-xs font-semibold leading-snug">{nudge.titulo}</p>
    <button
      type="button"
      onClick={() => onAccept(nudge)}
      className="shrink-0 rounded-md px-2.5 py-1 text-xs font-semibold"
      style={{ background: C.white, color: C.primary }}
    >
      {nudge.cta.label}
    </button>
    <button
      type="button"
      aria-label="Descartar"
      onClick={() => onDismiss(nudge)}
      className="shrink-0"
      style={{ background: 'transparent', border: 0, color: 'rgba(255,255,255,.7)', cursor: 'pointer', padding: 0 }}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </button>
  </div>
);
